import {SubNav} from '@primer/react-brand'
import {isLink} from '../../../../lib/types/contentful/contentTypes/link'
import {isLinkGroup} from '../../../../lib/types/contentful/contentTypes/linkGroup'
import type {FlexSuiteSubNavProps} from './types'

export function FlexSuiteSubNav({navHeading, navSubHeading, navLinks, navCta}: FlexSuiteSubNavProps) {
  return (
    <SubNav>
      {navHeading && <SubNav.Heading href={navHeading.fields.href}>{navHeading.fields.text}</SubNav.Heading>}

      {navSubHeading && (
        <SubNav.SubHeading href={navSubHeading.fields.href}>{navSubHeading.fields.text}</SubNav.SubHeading>
      )}

      {navLinks?.map(
        linkOrLinkGroup =>
          (isLink(linkOrLinkGroup) && (
            <SubNav.Link key={linkOrLinkGroup.sys.id} href={linkOrLinkGroup.fields.href}>
              {linkOrLinkGroup.fields.text}
            </SubNav.Link>
          )) ||
          (isLinkGroup(linkOrLinkGroup) && (
            <SubNav.Link key={linkOrLinkGroup.sys.id} href="">
              {linkOrLinkGroup.fields.label}

              <SubNav.SubMenu>
                {linkOrLinkGroup.fields.links.map(link => (
                  <SubNav.Link key={link.sys.id} href={link.fields.href}>
                    {link.fields.text}
                  </SubNav.Link>
                ))}
              </SubNav.SubMenu>
            </SubNav.Link>
          )),
      )}

      {navCta && <SubNav.Action href={navCta.fields.href}>{navCta.fields.text}</SubNav.Action>}
    </SubNav>
  )
}
